import React from "react";
import defaultAvatar from './default_avatar.png';
import {clone} from "lodash";

const Avatar = (props) => {
  let newProps = clone(props)
  newProps.src ||= defaultAvatar
  newProps.width ||= 150
  newProps.alt ||= 'User Avatar'

  return <img {...newProps} alt={newProps.alt}/>
}

export default Avatar;